import { module } from "../app";
import * as commonConstants from '../constants/constantStrings';

module.directive('resolveFollowUp', [
  'modalService', 'FollowUpsDomain', '$ionicLoading', 'signalrService',
  function (modalService, FollowUpsDomain, $ionicLoading, signalrService) {
    return {
      restrict: "E",
      templateUrl: "views/templates/resolveFollowUp.html",
      scope: {
        followUp: "=",
        onResolved: "&",
        onCanceled: "&",
        onDeleted: "&?",
        isShowDeleteButton: "=?",
        isShowCancelButton: "=?",
        isShowResolveButton: "=?",
        isShowButtonsAsModal: "=?",
        checkIfStilOwning: "&?",
        registerScope: "&?"
      },
      link: async function (scope, element, ngModel) {

        scope.loadFollowUpFindings = async () => {
          let isLoaded = false;
          try {
            $ionicLoading.show({
              template: commonConstants.DEFAULT_LOAD_FU_FINDINGS_LOADING_MESSAGE
            });

            let canProceed = true;
            if (!signalrService.isConnected) {
              $ionicLoading.hide();
              await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
              canProceed = false;
            }

            if(canProceed){
              const followUpFindingsResponse = await FollowUpsDomain.loadFollowUpFindings(scope.followUp.Id);
              scope.findings = followUpFindingsResponse;
              $ionicLoading.hide();
              isLoaded = true;
            }
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_FU_FINDINGS_ERROR_MESSAGE);
          }
          return isLoaded;
        }

        scope.loadResolutions = async () => {
          try {
            const resp = await FollowUpsDomain.getResolutions();
            scope.resolutions = resp || [];
          } catch (errorResp) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResp || commonConstants.DEFAULT_LOAD_FU_RESOLUTIONS_ERROR_MESSAGE);
          }
        }

        scope.initializeDirective = async () => {
          scope.findings = null;
          scope.resolutions = [];

          let isLoaded = await scope.loadFollowUpFindings();

          if(isLoaded){
            await scope.loadResolutions();
          }
        }

        await scope.initializeDirective();

        if (scope.registerScope) {
          scope.registerScope({ scope: scope });
        }

        scope.areValidFuRequiredFields = () => {
          scope.highlightFuInvalidData = true;
          const isValid = !!scope.followUp.FUReason;
          return isValid;
        }

        scope.proceedResolveFollowUp = async () => {
          let canProceed = scope.areValidFuRequiredFields();
          if (!canProceed) {
            await modalService.showAlertAsync(commonConstants.DEFAULT_FU_RESOLUTION_REQUIRED_MESSAGE);
          }

          if (canProceed && !signalrService.isConnected) {
            await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
            canProceed = false;
          }

          if(canProceed && scope.checkIfStilOwning){
            $ionicLoading.show({template: commonConstants.processingLoaderMessage});
            const stilOwning = await scope.checkIfStilOwning();
            $ionicLoading.hide();
            if(!stilOwning){
              canProceed = false;
              scope.followUp.FUReason = '';
              if(scope.onCanceled){
                scope.followUp.isLostOwnership = true;
                await scope.onCanceled();
              }
            }
          }

          if(canProceed){
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_RESOLVE_FU_LOADING_MESSAGE
              });

              await FollowUpsDomain.resolveFollowUp(scope.followUp);
              $ionicLoading.hide();

              if(scope.onResolved){
                await scope.onResolved();
              }
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_RESOLVE_FU_ERROR_MESSAGE);
            }
          }
        }

        scope.formatDateString = (dateString) => {
          const date = new Date(dateString);
          const formattedDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
          return formattedDate;
        }

        scope.deleteFollowUp = async () => {
          const formattedRecallDate = scope.formatDateString(scope.followUp.RecallDate);
          const isConfirmed = await modalService.showConfirmationAsync(
            `Are you sure you want to delete this follow-up due on date ${formattedRecallDate}?`
          );
          if(isConfirmed){
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_DELETE_FU_LOADING_MESSAGE
              });

              let canProceed = true;
              if (!signalrService.isConnected) {
                $ionicLoading.hide();
                await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
                canProceed = false;
              }

              if(canProceed && scope.checkIfStilOwning){
                $ionicLoading.show({template: commonConstants.processingLoaderMessage});
                const stilOwning = await scope.checkIfStilOwning();
                $ionicLoading.hide();
                if(!stilOwning){
                  canProceed = false;
                  scope.followUp.FUReason = '';
                  if(scope.onCanceled){
                    scope.followUp.isLostOwnership = true;
                    await scope.onCanceled();
                  }
                }
              }

              if(canProceed){
                await FollowUpsDomain.deleteFollowUp(scope.followUp.Id);
                $ionicLoading.hide();

                if(scope.onResolved){
                  await scope.onResolved();
                }
              }
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_REMOVE_FU_ERROR_MESSAGE);
            }
          }
        };

        scope.cancelResolveFollowUp = async () => {
          if(scope.onCanceled){
            await scope.onCanceled();
          }
        }
      }
    };
  }]);


// WEBPACK FOOTER //
// ./src/scripts/directives/resolve-follow-up.js